module.exports = __webpack_public_path__ + "static/media/thumbnail.06f07cff.jpg";